// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.asset-card--dropdown,
.asset-card--input,
.asset-card--checkbox {
  width: calc(100% - 140px);
}

.asset-card .new-card__buttons {
  margin: auto auto 7px 17.5px;
  padding-top: 50px;
}

.asset-card .new-card__buttons--mobile {
  margin: 0;
  padding-top: 0;
}

.asset-card .p-tabview {
  max-height: calc(100% - 99px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.asset-card .p-tabview .p-tabview-panels {
  flex-grow: 1;
  overflow-y: auto;
  padding-right: 10px;
}

.asset-card .p-tabview .p-tabview-panels::-webkit-scrollbar {
  width: 8px;
}

.asset-card .p-tabview .p-tabview-panels::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.asset-card .p-tabview .p-tabview-panels::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.asset-card .p-tabview .p-tabview-panels::-webkit-scrollbar-thumb:hover {
  background: #555;
}

@media (max-width: 768px) {
  .asset-card {
    height: auto !important;
  }

  .asset-card--dropdown,
  .asset-card--input,
  .asset-card--checkbox {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .asset-card .card-row--bottom-margin,
  .asset-card__column .flex.justify-content-between.align-items-center,
  .asset-card .p-inputtext,
  .asset-card .p-dropdown {
    min-width: 0 !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }

  .asset-card .task-card__label {
    width: 100% !important;
  }

  .asset-card__column .flex.justify-content-between.align-items-center,
  .asset-card .card-row--bottom-margin {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 0.25rem;
  }

  .asset-card .card-row--bottom-margin > .flex.flex-row,
  .asset-card .card-row--bottom-margin .asset-card--input {
    width: 100% !important;
  }

  .task-card__asset-edit-btn {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/AssetCard.css"],"names":[],"mappings":"AAAA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;;;;IAIE,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,iCAAiC;IACjC,+BAA+B;IAC/B,YAAY;EACd;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".asset-card--dropdown,\n.asset-card--input,\n.asset-card--checkbox {\n  width: calc(100% - 140px);\n}\n\n.asset-card .new-card__buttons {\n  margin: auto auto 7px 17.5px;\n  padding-top: 50px;\n}\n\n.asset-card .new-card__buttons--mobile {\n  margin: 0;\n  padding-top: 0;\n}\n\n.asset-card .p-tabview {\n  max-height: calc(100% - 99px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.asset-card .p-tabview .p-tabview-panels {\n  flex-grow: 1;\n  overflow-y: auto;\n  padding-right: 10px;\n}\n\n.asset-card .p-tabview .p-tabview-panels::-webkit-scrollbar {\n  width: 8px;\n}\n\n.asset-card .p-tabview .p-tabview-panels::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.asset-card .p-tabview .p-tabview-panels::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 10px;\n}\n\n.asset-card .p-tabview .p-tabview-panels::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n@media (max-width: 768px) {\n  .asset-card {\n    height: auto !important;\n  }\n\n  .asset-card--dropdown,\n  .asset-card--input,\n  .asset-card--checkbox {\n    width: 100% !important;\n    min-width: 0 !important;\n    max-width: 100% !important;\n    box-sizing: border-box;\n  }\n\n  .asset-card .card-row--bottom-margin,\n  .asset-card__column .flex.justify-content-between.align-items-center,\n  .asset-card .p-inputtext,\n  .asset-card .p-dropdown {\n    min-width: 0 !important;\n    max-width: 100% !important;\n    box-sizing: border-box;\n  }\n\n  .asset-card .task-card__label {\n    width: 100% !important;\n  }\n\n  .asset-card__column .flex.justify-content-between.align-items-center,\n  .asset-card .card-row--bottom-margin {\n    flex-direction: column !important;\n    align-items: stretch !important;\n    gap: 0.25rem;\n  }\n\n  .asset-card .card-row--bottom-margin > .flex.flex-row,\n  .asset-card .card-row--bottom-margin .asset-card--input {\n    width: 100% !important;\n  }\n\n  .task-card__asset-edit-btn {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
